import React, { useState, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import { pathOr } from "ramda";
import { setPopup } from "../../actions/popupAction";
import {
  PatientCountAction,
  activePatientSagaAction,
  notificationCountAction,
  chatpatient,
  liveAgentChatCountAction,
  liveAgentChatSagaAction,
} from "../../sagas/saga-actions";
import UserService from "../../service/UserService";
import DepartmentService from "../../service/DepartmentService";
import { SingleFormikSelect } from "../../components/select/singleSelect";
import CustomModal from "../../components/customModal";
import Checkbox from "antd/lib/checkbox/Checkbox";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import "./style.scss";
import useWindowDimensions from "../../components/custom-hooks/useWindowDimensions";
import { MOBILE_WIDTH } from "../../constants/constants";

const userservice = new UserService();
const departmentService = new DepartmentService();

const TransferPopup = (props) => {
  const [state, setState] = useState({
    initialValues: {
      userName: {},
      departmentName: {},
    },
    loading: false,
    userList: [],
    departmentList: [],
    confirm: false,
  });
  const { user } = props;
  const dispatch = useDispatch();
  const actionRef = useRef(false);
  const { width } = useWindowDimensions();
  const history = useHistory();

  const schema = Yup.object().shape({
    userName:
      (props.isLiveAgent || !user.isConfig) &&
      Yup.object().shape({
        id: Yup.string().required("User name is required"),
      }),
    departmentName:
      !props.isLiveAgent &&
      user.isConfig &&
      Yup.object().shape({
        id: Yup.string().required("Department is required"),
      }),
  });

  const handleRememberMe = (e) => {
    setState((st) => ({
      ...st,
      confirm: e,
    }));
  };

  const handleSuccess = (flag) => {
    const { user } = props;
    if (flag) {
      if (user?.id) {
        const obj = {
          offset: 0,
          userId: user.id,
        };
        props.liveAgentChatSaga(obj);
      }
      props.liveAgentChatCount();
      props.handleAgentChat(false);
    } else {
      if (user?.id) {
        const obj = {
          offset: 0,
          userId: user.id,
        };

        props.activePatientSagaAction(obj);
      }
      props.PatientCount();
      props.handleChat(false);
    }
    props.handleCancel();
    props.chatPatient({});
  };

  const handleTransfer = async (userName, department) => {
    if (actionRef && actionRef.current) return;
    else {
      const { patients } = props;
      const object = {
        userId: userName.id,
        departmentId: department.id,
        ...(props.isLiveAgent
          ? { clientId: patients.patient.id }
          : { patientId: patients.patient.id }),
      };
      try {
        actionRef.current = true;
        const response = props.isLiveAgent
          ? await userservice.transferChat(object)
          : await userservice.transferPatient(object);
        throwMessage("success", response);
        handleSuccess(props.isLiveAgent);
        if (width < MOBILE_WIDTH) {
          history.push("/");
        }
      } catch (err) {
        actionRef.current = false;
        throwMessage("error", err);
      }
      actionRef.current = false;
    }
  };

  const throwMessage = (type, response) => {
    dispatch(
      setPopup({
        customPopupMessage: true,
        messageType: type,
        message:
          type === "success"
            ? response.data.message
            : pathOr(
                "Something went wrong",
                ["response", "data", "message"],
                response
              ),
      })
    );
  };

  const fetchDepartments = (page = 1, searchQuery, isScrolling) => {
    const practiceId = user.practiceId;
    return new Promise(async (resolve, reject) => {
      if (practiceId) {
        try {
          const {
            rows: departmentList = [],
            count = 0,
          } = await departmentService.getDepartmentsByPractiseId(
            practiceId,
            page,
            searchQuery
          );
          setState((st) => ({
            ...st,
            departmentList: isScrolling
              ? [...st.departmentList, ...departmentList]
              : departmentList,
          }));
          resolve(count);
        } catch (err) {
          reject(err);
        }
      } else {
        resolve([]);
        setState((st) => ({
          ...st,
          departmentList: [],
        }));
      }
    });
  };

  const fetchUsers = (
    page = 1,
    searchQuery,
    isScrolling,
    forTransfer = true,
    type = props.isLiveAgent ? "1" : "0",
    departmentId = state.initialValues.departmentName?.id
  ) => {
    if (props.isLiveAgent || !user.isConfig) {
      const practiceId = user.practiceId;
      return new Promise(async (resolve, reject) => {
        if (practiceId) {
          try {
            let {
              rows: userList = [],
              count = 0,
            } = await userservice.getPortalUsersForAdmin(
              practiceId,
              page,
              searchQuery,
              forTransfer,
              type
            );
            // filter out BA user whose number will be null
            userList = userList.filter((user) => user.liveChatNumber);
            setState((st) => ({
              ...st,
              userList: isScrolling ? [...st.userList, ...userList] : userList,
            }));
            resolve(count);
          } catch (err) {
            reject(err);
          }
        } else {
          resolve([]);
          setState((st) => ({
            ...st,
            userList: [],
          }));
        }
      });
    } else {
      return new Promise(async (resolve, reject) => {
        if (departmentId) {
          try {
            setState((st) => ({
              ...st,
              loading: true,
            }));
            const {
              rows: userList = [],
              count = 0,
            } = await departmentService.getUsersByDepartmentId(
              departmentId,
              page,
              searchQuery
            );
            setState((st) => ({
              ...st,
              userList: isScrolling ? [...st.userList, ...userList] : userList,
              loading: false,
            }));
            resolve(count);
          } catch (err) {
            reject(err);
          }
        } else {
          resolve([]);
          setState((st) => ({
            ...st,
            userList: [],
          }));
        }
      });
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={state?.initialValues}
      validationSchema={schema}
      validateOnMount
    >
      {({ values, isValid, setFieldValue, validateForm, errors }) => {
        return (
          <CustomModal
            title="Transfer Number"
            submitButtonText="Transfer"
            cancelButtonText="Cancel"
            handleDelete={() =>
              handleTransfer(values.userName, values.departmentName)
            }
            handleCancel={props.handleCancel}
            isVisible={true}
            disabled={!state.confirm}
          >
            <p className="default-content">
              Transfer this chat to another user.
            </p>
            <Form className="fields-wrapper">
              <>
                {!props.isLiveAgent &&
                  user.isConfig && (
                    <section className="form-row">
                      <SingleFormikSelect
                        data={state.departmentList}
                        name="departmentName"
                        onChange={(value) => {
                          setState((st) => ({
                            ...st,
                            confirm: false,
                            initialValues: {
                              ...st.initialValues,
                              departmentName: value,
                            },
                          }));
                          fetchUsers(1, "", false, true, "0", value.id);
                          setFieldValue("userName", {});
                          setTimeout(validateForm, 0);
                        }}
                        optionLabelProp="name"
                        required={true}
                        optionValueProp="id"
                        placeholder="Select Department"
                        title="Department"
                        infiniteScroll
                        loadMoreData={fetchDepartments}
                        loading={false}
                      />
                    </section>
                  )}
                <section className="form-row">
                  <SingleFormikSelect
                    customClass="username-dropdown"
                    data={state.userList}
                    name="userName"
                    onChange={(value) => {
                      setState((st) => {
                        return {
                          ...st,
                          confirm: false,
                        };
                      });
                      setTimeout(validateForm, 0);
                    }}
                    optionLabelProp="username"
                    optionValueProp="id"
                    placeholder="Select User"
                    title="User"
                    infiniteScroll
                    loadMoreData={fetchUsers}
                    loading={state.loading}
                    required={props.isLiveAgent || !user.isConfig}
                  />
                </section>
                <Checkbox
                  onChange={(e) => handleRememberMe(e?.target?.checked)}
                  checked={state.confirm}
                  disabled={!isValid}
                >
                  <span className="confirm-transfer">
                    I confirm to transfer this chat to another user
                  </span>
                </Checkbox>
              </>
            </Form>
          </CustomModal>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = (state) => ({
  user: state.login.user,
  patients: state.patients,
});

const mapDispatchToProps = (dispatch) => {
  return {
    PatientCount: bindActionCreators(PatientCountAction, dispatch),
    activePatientSagaAction: bindActionCreators(
      activePatientSagaAction,
      dispatch
    ),
    NotificationCount: bindActionCreators(notificationCountAction, dispatch),
    chatPatient: bindActionCreators(chatpatient, dispatch),
    liveAgentChatCount: bindActionCreators(liveAgentChatCountAction, dispatch),
    liveAgentChatSaga: bindActionCreators(liveAgentChatSagaAction, dispatch),
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TransferPopup)
);
